import { useState } from "react";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import api from "@/lib/api";

export default function SecurityManager() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 8) {
      toast.error("Le nouveau mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("La confirmation ne correspond pas au nouveau mot de passe.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/admin/change-password", {
        current_password: currentPassword,
        new_password: newPassword,
      });
      toast.success("Mot de passe mis à jour.");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Impossible de changer le mot de passe.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-md space-y-8" data-testid="security-manager">
      <div className="flex items-center gap-3">
        <ShieldCheck className="h-6 w-6 text-gold" strokeWidth={1.5} />
        <div>
          <h2 className="font-serif text-xl font-bold text-ivory">Sécurité du compte</h2>
          <p className="text-xs uppercase tracking-[0.2em] text-ivory/40">Mot de passe administrateur</p>
        </div>
      </div>

      <form onSubmit={submit} className="space-y-5 rounded-lg border border-white/10 bg-coal/60 p-6">
        <div>
          <label className="mb-2 block text-xs font-semibold uppercase tracking-[0.15em] text-ivory/50">
            Mot de passe actuel
          </label>
          <input
            type="password"
            autoComplete="current-password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            className="input-dark"
            data-testid="security-current-password"
            required
          />
        </div>
        <div>
          <label className="mb-2 block text-xs font-semibold uppercase tracking-[0.15em] text-ivory/50">
            Nouveau mot de passe
          </label>
          <input
            type="password"
            autoComplete="new-password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="input-dark"
            data-testid="security-new-password"
            required
            minLength={8}
          />
          <p className="mt-1 text-xs text-ivory/40">8 caractères minimum.</p>
        </div>
        <div>
          <label className="mb-2 block text-xs font-semibold uppercase tracking-[0.15em] text-ivory/50">
            Confirmer le nouveau mot de passe
          </label>
          <input
            type="password"
            autoComplete="new-password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="input-dark"
            data-testid="security-confirm-password"
            required
            minLength={8}
          />
        </div>
        <button type="submit" disabled={saving} className="btn-primary" data-testid="security-submit-button">
          {saving ? "Enregistrement…" : "Changer le mot de passe"}
        </button>
      </form>
    </div>
  );
}
